if (document.getElementById("map")) {
    const filterGroup = document.getElementById("map-filters");
    const reset = document.getElementById("map-reset");

    maptilersdk.config.apiKey = 'vqQOuMawXvsajWVDOdIQ';
    maptilersdk.config.telemetry = false;

    const map = new maptilersdk.Map({
        container: "map",
        style: "https://api.maptiler.com/maps/0195f638-6b00-70e2-b257-af72f9a27769/style.json",
        center: [10.451526, 51.82],
        zoom: 5, //window.innerWidth <= 800 ? 4.0 : 5.3
        minZoom: 4,
        maxZoom: 14,
        maxBounds: [
            // Set bounds roughly to Central Europe
            [-4.078857, 44.608927], // Southwest coordinates
            [24.848095, 56.724607], // Northeast coordinates
        ],
        navigationControl: false,
        geolocateControl: true,
        scrollZoom: false,
        draggable: false,
        touchZoomRotate: false,
    });

    map.addControl(new maptilersdk.MaptilerNavigationControl({
        showCompass: false,
        showZoom: true,
        visualizePitch: false,
    }), 'top-right');

    map.setLanguage(maptilersdk.Language[visitorLanguage]);

    const regionMarkerIcon = await map.loadImage('/images/map/triangle-light-green.png');
    const partnerMarkerIcon = await map.loadImage('/images/map/circle-green.png');

    function addFilterCheckbox(feature, layerID) {
        let input = document.createElement("input");
        input.checked = true;
        input.dataset.type = feature.properties.locationType;
        input.id = layerID;
        input.type = "checkbox";
        filterGroup.appendChild(input);

        let label = document.createElement("label");
        label.setAttribute("for", layerID);
        label.textContent = feature.properties.locationLabel;
        filterGroup.appendChild(label);
    }

    map.on("load", function () {

        map.addImage('partner-marker', partnerMarkerIcon.data, {
            pixelRatio: 2,
            width: "52px",
        });

        map.addImage('region-marker', regionMarkerIcon.data, {
            pixelRatio: 2,
            width: "52px",
        });

        map.addSource("locations", {
            cluster: true,
            clusterMaxZoom: 3, // Max zoom to cluster points on
            clusterRadius: 50, // Radius of each cluster when clustering points (defaults to 50)
            data: locations,
            type: "geojson",
        });

        locations.features.forEach(function (feature) {
            let symbol = feature.properties["icon"];
            let layerID = "poi-" + symbol;

            // Add a layer for this symbol type if it hasn't been added already.
            if (!map.getLayer(layerID)) {
                map.addLayer({
                    id: layerID,
                    type: "symbol",
                    source: "locations",
                    layout: {
                        "icon-image": "{icon}-marker",
                        "icon-overlap": "always",
                        "icon-offset": [0, -33], // Add a negative second value to shift upwards
                        "icon-size": .4,
                    },
                    filter: ["==", "icon", symbol],
                });

                // Add on click event handling to show/hide popups
                map.on("click", layerID, function (e) {
                    let coordinates = e.features[0].geometry.coordinates.slice();
                    let description = e.features[0].properties.description;

                    // Ensure that if the map is zoomed out such that multiple
                    // copies of the feature are visible, the popup appears
                    // over the copy being pointed to.
                    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                    }

                    popup = new maptilersdk.Popup({
                        anchor: "bottom-left",
                        className: "map-location-popup",
                        closeButton: true,
                        closeOnClick: true,
                        closeOnMove: false,
                        offset: [10, -50],
                    })
                        .setLngLat(coordinates)
                        .setHTML(description)
                        .setMaxWidth("300px")
                        .addTo(map);
                });

                // Change the cursor to a pointer when the mouse is over the locations layer.
                map.on("mouseenter", layerID, function () {
                    map.getCanvas().style.cursor = "pointer";
                });

                // Change it back to a pointer when it leaves.
                map.on("mouseleave", layerID, function () {
                    map.getCanvas().style.cursor = "";
                });

                // Add checkbox and label elements for the layer.
                addFilterCheckbox(feature, layerID);
            }
        });

        // When the checkbox changes, update the location data.
        let filteredLocations = {...locations};

        let popup = null;

        for (let input of filterGroup.getElementsByTagName("input")) {
            input.addEventListener("change", function (e) {
                const locationType = e.target.dataset.type;

                if (e.target.checked === false) {
                    filteredLocations.features = filteredLocations.features.filter(
                        (feature) => feature.properties.locationType !== locationType
                    );

                    if (popup !== null) {
                        popup.remove();
                    }
                } else {
                    const features = locations.features.filter(
                        (feature) => feature.properties.locationType === locationType
                    );

                    filteredLocations.features =
                        filteredLocations.features.concat(features);
                }

                map.getSource("locations").setData(filteredLocations);
            });
        }

        map.addLayer({
            id: "clusters",
            type: "circle",
            source: "locations",
            filter: ["has", "point_count"],
            paint: {
                // Use step expressions (https://maplibre.org/maplibre-gl-js-docs/style-spec/#expressions-step)
                // with three steps to implement three types of circles:
                //   * Green, 20px circles when point count is less than 2
                //   * Yellow, 30px circles when point count is between 2 and 3
                //   * Pink, 40px circles when point count is greater than or equal to 4
                "circle-color": [
                    "step",
                    ["get", "point_count"],
                    "#8ddc49",
                    3,
                    "#70B62C",
                    4,
                    "#008C34",
                ],
                "circle-radius": ["step", ["get", "point_count"], 20, 3, 30, 4, 40],
            },
        });

        map.addLayer({
            id: "cluster-count",
            type: "symbol",
            source: "locations",
            filter: ["has", "point_count"],
            layout: {
                "text-field": "{point_count_abbreviated}",
                "text-size": 14,
            },
        });

        map.on("click", "clusters", function (e) {
            let features = map.queryRenderedFeatures(e.point, {
                layers: ["clusters"],
            });
            let clusterId = features[0].properties.cluster_id;

            map.getSource("locations").getClusterExpansionZoom(clusterId, function (err, zoom) {
                if (err) return;

                map.easeTo({
                    center: features[0].geometry.coordinates,
                    zoom: zoom,
                });
            });
        });

        reset.addEventListener("click", function (e) {
            map.jumpTo({
                center: map.getCenter(),
                zoom: map.getZoom(),
            });

            map.getSource("locations").setData(locations);

            filteredLocations = {...locations};

            for (let input of filterGroup.getElementsByTagName("input")) {
                input.checked = true;
            }
        });

    });

    map.on("resize", function () {
        map.jumpTo({
            zoom: window.innerWidth <= 800 ? 4.0 : 5.3,
        });
    })
}
